<div class="row g-3">
  <!-- Online Alert Card -->
  <div class="col-lg-4 mb-4 card">
    <div class="card-body">
      <div class="">
        <div class="d-flex justify-content-end">
          <img src="/assets/images/profile-icon/9.png" class="img-fluid" style="height: 24px;">
        </div>

        <div class="h5 fw-semibold mb-3">Online Alert</div>
        <div class="display-4 fw-bolder" style="height: 75px; margin-top: 25px; color: #FB6058;font-size: 32px">No Alerts</div>
        <div class="small text-muted fw-medium">(Last 30 days)</div>
      </div>
    </div>
  </div>

  <!-- Count Cards -->
  <div class="col-lg-4 mb-4 card">
    <div class="card-body">
      <div class=" p-0">
        <div class="row g-0">
          <div class="col-6">
            <button type="button" class="btn btn-light w-100 border-0 text-start p-3">
              <div class="fw-bolder" style="color: #50B5F5;font-size: 24px">
                <span *ngIf="!detailsCardLoader && countCardDetail['station']" [CountTo]="countCardDetail['station']" [from]="countFrom" [duration]="countDuration"></span>
                <span *ngIf="!detailsCardLoader && !countCardDetail['station']">{{countCardDetail['station']}}</span>
                <span *ngIf="detailsCardLoader" class="d-flex justify-content-center align-items-center" style="height: 45px;">
                  <img src="/assets/images/load.gif" style="width: 40px;" class="img-fluid">
                </span>
              </div>
              <div>Total Stations</div>
            </button>

            <button type="button" class="btn btn-light w-100 border-0 text-start p-3">
              <div class="fw-bolder" style="color: #50B5F5;font-size: 24px">
                <span *ngIf="!detailsCardLoader && countCardDetail['parameter']" [CountTo]="countCardDetail['parameter']" [from]="countFrom" [duration]="countDuration"></span>
                <span *ngIf="!detailsCardLoader && !countCardDetail['parameter']">{{countCardDetail['parameter']}}</span>
                <span *ngIf="detailsCardLoader" class="d-flex justify-content-center align-items-center" style="height: 45px;">
                  <img src="/assets/images/load.gif" style="width: 40px;" class="img-fluid">
                </span>
              </div>
              <div>Total Parameters</div>
            </button>
          </div>

          <div class="col-6">
            <button type="button" class="btn btn-light w-100 border-0 text-start p-3">
              <div class="fw-bolder" style="color: #50B5F5;font-size: 24px">
                <span *ngIf="!detailsCardLoader && countCardDetail['device']" [CountTo]="countCardDetail['device']" [from]="countFrom" [duration]="countDuration"></span>
                <span *ngIf="!detailsCardLoader && !countCardDetail['device']">{{countCardDetail['device']}}</span>
                <span *ngIf="detailsCardLoader" class="d-flex justify-content-center align-items-center" style="height: 45px;">
                  <img src="/assets/images/load.gif" style="width: 40px;" class="img-fluid">
                </span>
              </div>
              <div>Total Devices</div>
            </button>

            <button type="button" class="btn btn-light w-100 border-0 text-start p-3">
              <div class="fw-bolder" style="color: #50B5F5;font-size: 24px">
                <span *ngIf="!detailsResponseCardLoader && responseCardDetail['response']" [CountTo]="responseCardDetail['response']" [from]="countFrom" [duration]="countDuration"></span>
                <span *ngIf="!detailsResponseCardLoader && !responseCardDetail['response']">{{responseCardDetail['response']}}</span>
                <span *ngIf="detailsResponseCardLoader" class="d-flex justify-content-center align-items-center" style="height: 45px;">
                  <img src="/assets/images/load.gif" style="width: 40px;" class="img-fluid">
                </span>
              </div>
              <div>Total Responses</div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Exceedance Card -->
  <div class="col-lg-4 mb-4 card">
    <div class="card-body">
      <div class="">
        <div class="d-flex justify-content-end">
          <img src="/assets/images/profile-icon/10.png" class="img-fluid" style="height: 24px;">
        </div>

        <div class="h5 fw-semibold mb-3">Exceedance <span class="display-5 fw-bolder" style="color: #7F4DC0;">{{totalExceedance}}</span> <span class="small text-muted">(Past 24 hours)</span></div>

        <div style="margin-top: 5px;">
          <div *ngIf="exceedanceGraph" [hidden]="exccedanceCardLoader" [chart]="exceedanceChart" style="height: 110px;"></div>

          <div *ngIf="!exceedanceGraph" [hidden]="exccedanceCardLoader" style="height: 98px;">
            <div class="display-4 fw-bolder" style="color: #FB6058;font-size: 32px">No Exceedance</div>
          </div>

          <div *ngIf="exccedanceCardLoader" class="d-flex justify-content-center align-items-center" style="height: 110px;">
            <img src="/assets/images/load.gif" class="img-fluid">
          </div>
        </div>

        <div *ngIf="exceedanceGraph" [hidden]="exccedanceCardLoader" class="text-end">
          <a href="#" class="text-decoration-none" data-bs-toggle="modal" (click)="getExceedanceList()" data-bs-target="#exceedancePopupList">List View</a>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Exceedance Modal -->
<div class="modal fade" id="exceedancePopupList" tabindex="-1" aria-labelledby="exceedancePopupListLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exceedancePopupListLabel">Exceedance List (Past 24 Hours)</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <div class="table-responsive">
          <table class="table">
            <thead>
            <tr>
              <th>Station Name</th>
              <th>Station Type</th>
              <th>Parameter Name</th>
              <th>Exceedance Date & Time</th>
              <th>Prescribed Limit</th>
              <th>Exceedance Value</th>
            </tr>
            </thead>

            <tbody *ngIf="!exceedanceListPopupLoader">
            <tr *ngFor="let exceedance of exceedanceList | keyvalue">
              <td>{{exceedance.value.station_name}}</td>
              <td>{{exceedance.value.station_type}}</td>
              <td>{{exceedance.value.name}}</td>
              <td>{{exceedance.value.excedance_date | date: 'dd MMM yyyy HH:mm'}}</td>
              <td>
                  <span *ngIf="exceedance.value.min">
                    {{exceedance.value.min}}
                  </span>
                <span *ngIf="exceedance.value.min && exceedance.value.max">
                    -
                  </span>
                <span *ngIf="!exceedance.value.min && !exceedance.value.max">
                    NA
                  </span>
                <span *ngIf="exceedance.value.max">
                    {{exceedance.value.max}}
                  </span>
                <span>{{exceedance.value.stdunit}}</span>
              </td>
              <td>{{exceedance.value.value}} {{exceedance.value.stdunit}}</td>
            </tr>
            </tbody>

            <tbody *ngIf="exceedanceListPopupLoader">
            <tr>
              <td colspan="6" class="text-center py-5">
                <img src="/assets/images/load.gif" class="img-fluid">
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
